export default __webpack_public_path__ + "media/WixMadeforDisplay_W_Rg.9d488db0.woff";